import { Link } from 'react-router-dom';
import { t } from '../hooks/useT';

export function DiscoverPage() {
  return (
    <main className="page marketing">
      <article className="marketing-article">
        <Link to="/" className="link-muted legal-back">{t('legal.back')}</Link>
        <h1>{t('discover.title')}</h1>
        <p className="marketing-lead">{t('discover.lead')}</p>

        <section>
          <h2>{t('discover.whatTitle')}</h2>
          <p>{t('discover.whatP1')}</p>
          <p>{t('discover.whatP2')}</p>
        </section>

        <section>
          <h2>{t('discover.whoTitle')}</h2>
          <p>{t('discover.whoP1')}</p>
        </section>

        <section>
          <h2>{t('discover.modesTitle')}</h2>
          <h3>{t('discover.modeDailyTitle')}</h3>
          <p>{t('discover.modeDailyDesc')}</p>
          <h3>{t('discover.modeArchivesTitle')}</h3>
          <p>{t('discover.modeArchivesDesc')}</p>
          <h3>{t('discover.modeTopTitle')}</h3>
          <p>{t('discover.modeTopDesc')}</p>
        </section>

        <section>
          <h2>{t('discover.accountTitle')}</h2>
          <p>{t('discover.accountP1')}</p>
          <ul>
            <li>{t('discover.accountPerk1')}</li>
            <li>{t('discover.accountPerk2')}</li>
            <li>{t('discover.accountPerk3')}</li>
          </ul>
          <p>{t('discover.accountP2')}</p>
        </section>

        <section>
          <h2>{t('discover.premiumTitle')}</h2>
          <p>{t('discover.premiumP1')}</p>
          <p>{t('discover.premiumP2')}</p>
        </section>

        <section>
          <h2>{t('discover.photosTitle')}</h2>
          <p>{t('discover.photosP1')}</p>
        </section>

        <section className="marketing-cta-inline">
          <h2>{t('discover.ctaTitle')}</h2>
          <p>{t('discover.ctaDesc')}</p>
          <div className="cta-row">
            <Link to="/play" className="btn primary">{t('landing.cta')}</Link>
            <Link to="/login" className="btn secondary">{t('landing.login')}</Link>
          </div>
        </section>
      </article>
    </main>
  );
}
